export class DeleteDevOpsActionRequest {
    eventRuleId?: string;
}